import { render, staticRenderFns } from "./CaseType.vue?vue&type=template&id=9fd61ec2&scoped=true&"
import script from "./CaseType.vue?vue&type=script&lang=js&"
export * from "./CaseType.vue?vue&type=script&lang=js&"
import style0 from "./CaseType.vue?vue&type=style&index=0&id=9fd61ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd61ec2",
  null
  
)

export default component.exports